export const formatDate = (date: string) => {
  return new Date(date)
    .toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'});
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', currencyDisplay: 'code'}).format(value);
};

